// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"c9ff9113","365":"db2a566a","650":"93c82ac6","654":"df11d478"}[chunkId] + ".chunk.css";
};